import { render, staticRenderFns } from "./FkConfig.vue?vue&type=template&id=36bcac46&scoped=true"
import script from "./FkConfig.vue?vue&type=script&lang=js"
export * from "./FkConfig.vue?vue&type=script&lang=js"
import style0 from "./FkConfig.vue?vue&type=style&index=0&id=36bcac46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bcac46",
  null
  
)

export default component.exports